type ClassImplementation = new (...args: unknown[]) => unknown;

export function Singleton<T extends ClassImplementation>(Class: T): T {
  return new Proxy(Class, {
    instance: null,
    construct(TargetClass: ClassImplementation, args: unknown[]) {
      if (!this.instance) {
        this.instance = new TargetClass(...args);
      }
      return this.instance;
    },
  } as ProxyHandler<T> & { instance: InstanceType<ClassImplementation> | null });
}
